module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-divider', [_vm._v("食宿人数" + _vm._s(_vm.sai_member_count) + "人")]), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "margin-bottom": "30px"
    },
    attrs: {
      "closable": false,
      "center": true,
      "title": "根据您这里填写的食宿人数配发餐券和乘坐大巴，请您认真核对!",
      "type": "error"
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "领队",
      "prop": "name"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.row.lingdui_shisu_count),
      callback: function($$v) {
        _vm.$set(_vm.row, "lingdui_shisu_count", $$v)
      },
      expression: "row.lingdui_shisu_count"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运动员",
      "prop": "name"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.row.yundongyuan_shisu_count),
      callback: function($$v) {
        _vm.$set(_vm.row, "yundongyuan_shisu_count", $$v)
      },
      expression: "row.yundongyuan_shisu_count"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教练员",
      "prop": "name"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.row.jiaolian_shisu_count),
      callback: function($$v) {
        _vm.$set(_vm.row, "jiaolian_shisu_count", $$v)
      },
      expression: "row.jiaolian_shisu_count"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "随行人员",
      "prop": "name"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.row.suixing_shisu_count),
      callback: function($$v) {
        _vm.$set(_vm.row, "suixing_shisu_count", $$v)
      },
      expression: "row.suixing_shisu_count"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "入住/离开酒店日期",
      "label-width": "220",
      "prop": "name"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "入住日期",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "timestamp",
      "end-placeholder": "离店日期"
    },
    model: {
      value: (_vm.row.date_range),
      callback: function($$v) {
        _vm.$set(_vm.row, "date_range", $$v)
      },
      expression: "row.date_range"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "plain": "",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm(2)
      }
    }
  }, [_vm._v("不要食宿")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm(1)
      }
    }
  }, [_vm._v("保存并选择食宿\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('FamliyPicker', {
    attrs: {
      "show": _vm.showFamliyPicker,
      "limit": 100,
      "defaultValue": _vm.formData.famliy
    },
    on: {
      "onChange": _vm.onFamliyChange,
      "onClose": function($event) {
        _vm.showFamliyPicker = false
      },
      "onConfirm": _vm.onFamliyConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b1ff7a3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep3Admin.vue
// module id = 1437
// module chunks = 0